import store from "../redux/store";
import { wsMsgSeparatorChar } from './websocketHelper';
import { initIndustries, updateMarketInfos } from '../redux/actions/sharedActions';


const arrMarketMsgField = [
    "marketCode", //0
    "marketName",
    "marketNameEn",
    "tradingDate",
    "tradingSessionId",
    "numberStockUp", //5
    "numberStockNoChange",
    "numberStockDown",
    "totalTradedQtty", 
    "totalTradedValue",
    "totalTradedQttyNM", //10
    "totalTradedValueNM",
    "totalTradedQttyPT",
    "totalTradedValuePT"
];

export const ProcessMsgIndustries = (message) => {
    try {
        if(message === undefined || message === null ||  message === "") {
            return;
        }
        //
        const industries = JSON.parse(message);
        store.dispatch(initIndustries(industries));
    } catch (error) {
        console.log("ProcessMsgIndustries", error);
    }
}

export const ProcessMsgCurrentTime = (message) => {
    try {
        if(message === undefined || message === null ||  message === "") {
            return;
        }
        //
        store.dispatch({ type: 'SetServerTime', payload: Number(message) });
    } catch (error) {
        console.log("ProcessMsgCurrentTime", error);
    }
}

//
export const ProcessMsgSysParam = (message) => {
    try {
        if(message === undefined || message === null ||  message === "") {
            return;
        }
        //
        store.dispatch({ type: 'SetSysParam', payload: JSON.parse(message) });
    } catch (error) {
        console.log("ProcessMsgSysParam", error);
    }
}

//
export const ProcessMsgConcurrent = (message) => {
    try {
        if(message === undefined || message === null ||  message === "") {
            return;
        }
        //
        const props = message.split("|");
        if(props?.length >= 4) {
            store.dispatch({ type: 'SetConcurrentInfo', payload: {
                time: props[0],
                total: props[1],
                max: props[2],
                current: props[3],
            }});
        }
    } catch (error) {
        console.log("ProcessMsgSysParam", error);
    }
}

//
export const ProcessMsgMarket = (message, isInit) => {
    try {
        if(message === undefined || message === null ||  message === "") {
            return;
        }
        //
        let _storedMarketDatas = isInit ? [] : (store.getState().gShared.marketInfos ?? []);
        const _recvMsgs = message.split(wsMsgSeparatorChar.ObjectSeparatorChar);

        for (let _indexIdx = 0; _indexIdx < _recvMsgs.length; _indexIdx++) {
            const _recvInfo = _recvMsgs[_indexIdx];
            if(_recvInfo === "") continue;
            //
            const _firstIdx = _recvInfo.indexOf(wsMsgSeparatorChar.PropSeparatorChar);
            const _marketCode = _recvInfo.substr(0, _firstIdx);
            let _rIndex = _storedMarketDatas.findIndex((item) => item.marketCode === _marketCode);
            if(_rIndex < 0) {
                _storedMarketDatas.push({ counter: 0, marketCode: _marketCode });
                _rIndex = _storedMarketDatas.length - 1;
            }
            //
            let _objTemp = _storedMarketDatas[_rIndex];
            const _arrData = _recvInfo.substr(_firstIdx).split(wsMsgSeparatorChar.PropSeparatorChar);
            for (let _dataIdx = 0; _dataIdx < _arrData.length; _dataIdx++) {
                if(_arrData[_dataIdx] === "") continue;
                //
                const _arrSubData = _arrData[_dataIdx].split(wsMsgSeparatorChar.DataSeparatorChar);
                const _propIndex = Number(_arrSubData[0]);
                if(_propIndex < arrMarketMsgField.length) {
                    let _objProp = arrMarketMsgField[_propIndex];
                    _objTemp[_objProp] = _arrSubData[1];
                }
            }
            //
            _objTemp.counter = _objTemp.counter + 1;
            _storedMarketDatas[_rIndex] = _objTemp;
        }
        //
        store.dispatch(updateMarketInfos(_storedMarketDatas));
    } catch (error) {
        console.log("ProcessMsgMarket", error);
    }
}